// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/deliverability/postmaster/:app_group_id/domain_reputation" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";

import { deliverabilityPostmasterAppGroupIdDomainReputation } from "./constants";
import type {
  DeliverabilityPostmasterAppGroupIdDomainReputationParams,
  DeliverabilityPostmasterAppGroupIdDomainReputationResult,
} from "./types";

export const getDataTableDeliverabilityPostmasterAppGroupIdDomainReputation = reactQueryTableFetcherAdapter(
  deliverabilityPostmasterAppGroupIdDomainReputation,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortby,
      sortdir,
    }: DeliverabilityPostmasterAppGroupIdDomainReputationParams
  ): Promise<DeliverabilityPostmasterAppGroupIdDomainReputationResult> => {
    return fetch(
      `/deliverability/postmaster/${appGroupId}/domain_reputation`,
      "GET",
      {
        groupby,
        query: serializeQueryObjects(query),
        limit,
        start,
        start_date: query?.start_date,
        end_date: query?.end_date,
        app_group_id: appGroupId,
        sortby,
        sortdir,
      },
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
